import { TYPE_PRESCRIPTION_STATUS_UNCONSENTED, TYPE_PRESCRIPTION_STATUS_CANCELLED, TYPE_PRESCRIPTION_STATUS_CONSENTED } from '../constants/Types';

export function formatConsentStatus(prescriptionStatusTypeId) {
  const consentStatuses = {
    [TYPE_PRESCRIPTION_STATUS_UNCONSENTED]: 'Unconsented',
    [TYPE_PRESCRIPTION_STATUS_CANCELLED]: 'Cancelled',
    [TYPE_PRESCRIPTION_STATUS_CONSENTED]: 'Consented',
  };
  return consentStatuses[prescriptionStatusTypeId] || '';
}

export const PRESCRIPTION_NOTIFICATION_HEADERS = {
  name: {
    default: true,
    direction: 1,
  },
  lastUpdatedAt: {
    default: false,
    direction: -1,
  },
};

export const PRESCRIPTION_HEADERS = {
  createdAt: {
    default: true,
    direction: 1,
  },
  prescriptions: {
    default: false,
    direction: -1,
  },
  payorNames: {
    default: false,
    direction: -1,
  },
  consentStatusTypeId: {
    default: false,
    direction: -1,
  },
  lastName: {
    default: false,
    direction: -1,
  },
  prescriptionNames: {
    default: false,
    direction: -1,
  },
  refillDate: {
    default: false,
    direction: -1,
  },
  patientId: {
    default: false,
    direction: -1,
  },
};

export function validateQueryStringValue(value, key) {
  if (key === 'status') {
    return ['Completed', 'Sent', 'Expired'].includes(value) ? value : null;
  } if (key === 'sortBy') {
    return PRESCRIPTION_HEADERS[key] ? value : null;
  } return value;
}
